<template>
  <div>
    <div class="template-item">
      <div class="w1200" style="padding-top: 90px">
        <div class="home-item-title">
          <div
            style="
              font-weight: 400;
              font-size: 44px;
              color: #1d2129;
              line-height: 70px;
              width: 568px;
            "
          >
            {{ navs[activeNav].title }}
          </div>
          <div
            style="
              font-size: 20px;
              color: #636e80;
              line-height: 40px;
              margin-top: 20px;
              width: 436px;
            "
          >
            {{ navs[activeNav].desc }}
          </div>
          <div class="home-item-input">
            <el-input
              v-model="phone"
              placeholder="请输入您的手机号码"
            ></el-input>
            <div class="home-item-btn center" @click="$router.push('/')">
              免费试用
            </div>
          </div>
        </div>
      </div>
      <img
        src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/在线表单@2x (1)-134650565.png"
        alt=""
      />
    </div>
    <div class="navs">
      <div class="w1200 between">
        <div
          v-for="(nav, index) in navs"
          :key="nav.path"
          class="center navs-item"
          :class="{ active: index === activeNav }"
          @click="setActiveNav(index)"
        >
          {{ nav.label }}
        </div>
      </div>
    </div>

    <div
      v-for="(item, index) in navs[activeNav].children"
      :key="index"
      class="children-item"
    >
      <div class="w1200 between children-item-box" style="padding: 80px 0">
        <div
          class="left"
          style="display: flex; flex-direction: column; gap: 14px"
        >
          <div
            class="title"
            style="font-size: 32px; color: #1d2129; line-height: 52px"
          >
            {{ item.title }}
          </div>
          <div
            class="desc"
            v-for="(desc, descIndex) in item.desc"
            :key="descIndex"
          >
            <div
              style="display: flex; align-items: center; gap: 10px"
              class="label"
            >
              <span
                style="
                  width: 8px;
                  height: 8px;
                  background: #2e98fe;
                  border-radius: 50%;
                "
                v-if="desc.label"
              ></span>
              {{ desc.label }}
            </div>
            <div
              style="
                margin-top: 10px;
                font-size: 14px;
                color: #495770;
                line-height: 24px;
                width: 395px;
              "
            >
              {{ desc.title }}
            </div>
          </div>
        </div>

        <div class="right"></div>
      </div>
    </div>
    <div class="template-footer">
      <div
        style="
          font-weight: 500;
          font-size: 40px;
          color: #1d2129;
          line-height: 44px;
        "
      >
        立即用CLOUD收集数据
      </div>
      <div class="home-item-input">
        <el-input v-model="phone" placeholder="请输入您的手机号码"></el-input>
        <div class="home-item-btn center hover-btn" @click="$router.push('/')">
          立即试用<i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <img
        src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/zuo-153419117.png"
        alt=""
        class="footer-left"
      />
      <img
        src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/you-153419114.png"
        alt=""
        class="footer-right"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "SiteTemplate",
  data() {
    return {
      phone: "",
      navs: [
        {
          label: "在线表单",
          path: "/site/product?type=1",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/在线表单@2x-115131677.png",
          children: [
            {
              title: "灵活的表单设计",
              desc: [
                {
                  label: "拖拽式配置",
                  title:
                    "灵活搭建，通过简单的拖拽和连接，即可设计出复杂的审批流、数据流与业务流",
                },
                {
                  label: "多终端适配",
                  title: "PC、手机、平板均可流畅填写，自动优化显示效果",
                },
                {
                  label: "模板库一键复用",
                  title: "100+行业模板（如报名、订单、反馈），开箱即用",
                },
              ],
            },
            {
              title: "智能数据管理",
              desc: [
                {
                  label: "实时协同",
                  title: "多人同时编辑表单，数据自动同步至云端",
                },
                {
                  label: "权限管控",
                  title: "按角色设置查看/编辑/导出权限，保障数据安全",
                },
                {
                  label: "自动化提醒",
                  title: "100+新提交数据时，通过微信、邮件、钉钉实时通知",
                },
              ],
            },
            {
              title: "深度集成与自动化",
              desc: [
                {
                  label: "连接现有系统",
                  title: "通过API对接ERP、CRM、OA等第三方平台",
                },
                {
                  label: "流程自动化",
                  title: "根据表单提交内容，自动触发审批、工单或数据更新",
                },
              ],
            },
            {
              title: "数据可视化与洞察",
              desc: [
                {
                  label: "动态仪表盘",
                  title: "将表单数据转化为图表、报表，关键指标一目了然",
                },
                {
                  label: "多维度分析",
                  title: "支持筛选、分组、对比，快速生成业务洞察",
                },
              ],
            },
          ],
          title: "智能表单设计，让数据收集更高效、更专业",
          desc: "拖拽式构建个性化表单｜无缝集成业务流｜数据自动分析与可视化",
        },
        {
          label: "业务流程",
          path: "/site/product?type=2",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/业务流程@2x-115131676.png",
          children: [
            {
              title: "可视化流程设计，像搭积木一样简单",
              desc: [
                {
                  label: "拖拽式配置",
                  title:
                    "灵活搭建，通过简单的拖拽和连接，即可设计出复杂的审批流、数据流与业务流",
                },
                {
                  label: "灵活表单引擎",
                  title:
                    "强大的表单设计器，支持丰富字段类型（单行文本、下拉框、联动选择、附件等），轻松收集与管理各类业务数据",
                },
              ],
            },
            {
              title: "智能审批与自动化",
              desc: [
                {
                  label: "条件分支路由",
                  title:
                    "可根据表单内容、提交人部门等条件，自动判断并流转至正确的审批人，实现“千人千面”的智能流程",
                },
                {
                  label: "自动化动作",
                  title:
                    "流程节点可自动触发后续动作，如更新数据、发送邮件/钉钉消息、生成报表等，彻底告别重复手动操作/编辑/导出权限，保障数据安全",
                },
              ],
            },
            {
              title: "全链路数据管理与洞察",
              desc: [
                {
                  label: "数据关联与整合",
                  title:
                    "打破信息孤岛。流程中产生的所有数据自动汇总，并可与其他业务模块（如CRM、项目管理）的数据关联，形成统一视图",
                },
                {
                  label: "实时数据分析仪表盘",
                  title:
                    "一键将流程数据转化为可视化的图表与报表，实时监控流程效率、瓶颈所在，为管理决策提供数据支撑",
                },
              ],
            },
            {
              title: "无缝集成与移动办公",
              desc: [
                {
                  label: "开放API接口",
                  title:
                    "轻松与您现有的ERP、OA、财务等系统对接，构建统一的企业应用平台",
                },
                {
                  label: "多端同步",
                  title:
                    "完美支持PC、手机APP、微信/钉钉小程序，审批与填报随时随地，办公不受限",
                },
              ],
            },
          ],
          title: "让业务流程化繁为简，驱动企业高效协作",
          desc: "轻松构建贴合业务需求的审批、管理与协作应用，实现数据互通与智能决策。",
        },
        {
          label: "统计报表",
          path: "/site/product?type=3",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/统计报表@2x-115131671.png",
          children: [
            {
              title: "一站式数据总览",
              desc: [
                {
                  label: "实时监控",
                  title:
                    "关键指标（如销售额、订单量、客户增长率）以最直观的图表形式实时刷新，业务脉搏尽在掌握",
                },
                {
                  label: "自定义布局",
                  title:
                    "拖拽即可自由组合看板模块，打造完全贴合您业务需求的专属视图。您关心的，永远在第一屏",
                },
              ],
            },
            {
              title: "深度分析与智能洞察",
              desc: [
                {
                  label: "多维度钻取",
                  title:
                    "点击图表任一区域，即可层层下钻，探究数据背后的“为什么”从宏观趋势到微观明细，脉络清晰",
                },
                {
                  label: "智能预警",
                  title:
                    "预设关键阈值（如库存下限、合同逾期）。当数据异常时，系统自动通过颜色、消息或邮件发出警报，让您快人一步，规避风险",
                },
              ],
            },
            {
              title: "高效协作与流程闭环",
              desc: [
                {
                  label: "无缝跳转",
                  title:
                    "在看板中看到问题数据？一键即可跳转至对应的表单或流程列表，直接进行处理，实现“洞察”到“行动”的无缝衔接",
                },
                {
                  label: "权限可控",
                  title:
                    "不同角色（如管理层、销售、财务）登录后，仅能看到与自己相关的数据和报表，安全与效率兼得",
                },
              ],
            },
            {
              title: "随时随地，移动办公",
              desc: [
                {
                  label: "",
                  title:
                    "原生适配手机与平板，复杂数据在掌心依然清晰可读。支持在移动端进行审批、查看报表，让决策不再受地点束缚",
                },
              ],
            },
          ],
          title: "您的智能业务指挥中心，数据驱动决策，一目了然",
          desc: "告别数据孤岛与繁琐报表，整合多源数据，通过可视化看板与实时预警，让业务状况一目了然，驱动精准决策。",
        },
      ],
      activeNav: 0,
    };
  },
  methods: {
    setActiveNav(index) {
      this.activeNav = index;
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
  watch: {
    "$route.query": {
      handler(val) {
        console.log(val);
        if (val.type) {
          this.activeNav = val.type - 1;
        } else {
          this.activeNav = 0;
        }
      },
      deep: true,
    },
  },
  mounted() {},
};
</script>

<style scoped lang="less">
.template-footer {
  height: 360px;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 106px;
  background: no-repeat
    url("https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/di-153419143.png");
  position: relative;
  .footer-left {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
  }
  .footer-right {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
  }

  .home-item-input {
    margin-top: 44px;
    display: flex;
    align-items: center;
    width: 520px;
    height: 60px;
    background: #fff;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #ffffff;
    padding-right: 6px;

    .el-input {
      flex: 1;
      border-radius: 10px;
      border-color: #ffffff;
      background-color: #ffffff;
      ::v-deep .el-input__inner {
        border: unset;
        line-height: 60px;
        font-size: 20px;
        &::placeholder {
          font-size: 20px;
          color: #606580;
          line-height: 60px;
        }
      }
    }
    .home-item-btn {
      width: 168px;
      height: 48px;
      background: #2e98fe;
      border-radius: 6px;
      color: #fff;
      font-weight: 500;
      font-size: 20px;
      line-height: 44px;
      gap: 12px;
    }
  }
}
.template-item {
  height: 565px;
  position: relative;
  img {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    object-fit: cover; /* 让图像覆盖整个容器 */
    z-index: -1;
  }

  .home-item-input {
    margin-top: 30px;
    display: flex;
    align-items: center;
    width: 291px;
    height: 44px;
    background: #ffffff;
    border-radius: 6px 6px 6px 6px;
    border: 1px solid #2e98fe;
    padding-right: 4px;

    .el-input {
      flex: 1;
      border-radius: 10px;
      border-color: #e5e5e5;
      background-color: #f5f5f5;
      ::v-deep .el-input__inner {
        border: unset;
      }
    }
    .home-item-btn {
      width: 100px;
      height: 36px;
      background: #2e98fe;
      border-radius: 4px;
      color: #fff;
    }
  }
}
.navs {
  height: 60px;
  background: rgba(0, 0, 0, 0.2);
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 110;
  width: 100%;
  margin-top: -60px;
  position: sticky;
  top: 0;
  .navs-item {
    flex: 1;
    height: 60px;
    font-size: 20px;
    color: #ffffff;
    line-height: 40px;
    cursor: pointer;
    &.active {
      background: #2e98fe;
    }
  }
}
.right {
  width: 587px;
  height: 380px;
  background: #ffffff;
  box-shadow: 0px 2px 6px 0px rgba(183, 189, 202, 0.2);
  border-radius: 6px 6px 6px 6px;
  border: 8px solid #f6f6f6;
}

.children-item {
  &:nth-child(odd) {
    // flex-direction: row-reverse;
    background: #fbfbfb;
    .children-item-box {
      flex-direction: row-reverse;
      .left {
        text-align: right;
        .desc {
          .label {
            flex-direction: row-reverse;
          }
        }
      }
    }
  }
}

.hover-btn {
  cursor: pointer;
  i {
    transition: all 0.1s ease-in-out;
  }
  &:hover {
    i {
      transform: translateX(10px);
    }
  }
}
</style>